






















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import TablePager from '@/components/TablePager.vue';
import TableField from '@/types/TableField';
import TableSortEventArgs from '@/types/TableSortEventArgs';
import PagerOptions, { InitPagerOptions } from '@/types/PagerOptions';
import SortOptions from '@/types/SortOptions';
import EntityReference from '@/types/EntityReference';
import { BTable, BButton, BCard, BCardHeader, BCardBody, BRow, BCol, BCollapse, BSpinner } from 'bootstrap-vue';
import ClientFilterOptions from '@/types/ClientFilterOptions';
import Configuration from '@/types/Configuration';
import InlineSvg from 'vue-inline-svg';
import ColumnHeader from '@/components/ColumnHeader.vue';
import AxiosService from '@/services/axiosService';
import i18n from '../i18n';

@Component({
    components: {
        'table-pager': TablePager,
        'b-table': BTable,
        'b-btn': BButton,
        'b-card': BCard,
        'b-card-header': BCardHeader,
        'b-card-body': BCardBody,
        'b-row': BRow,
        'b-col': BCol,
        'b-collapse': BCollapse,
        'inline-svg': InlineSvg,
        'column-header': ColumnHeader,
        'b-spinner': BSpinner
    }
})
export default class ClientList extends Vue {
    @Prop() refresh!: boolean
    @Prop() filter!: ClientFilterOptions

    clients: ClientListItem[] = [];
    listOptions: ClientListOptions = {
        filter: this.filter,
        pagerOptions: {
            page: 1,
            pageSize: Configuration.DefaultPageSize,
            pageCount: 1,
            rowCount: 0,
            rowStart: 0,
            rowEnd: 0
        },
        sortOptions: {
            sortBy: 'name',
            sortDirection: Configuration.SortDirectionAscending
        }
    };
    isBusy = false;
    apiAccessToken = this.$store.state.apiAccessToken;
    fields: TableField[] = [];
    allowedProjects: EntityReference[] = [];

    @Watch('refresh')
    refreshList(newVal: boolean) {
        if (newVal) {
            this.loadClients();
        }
    }

    @Watch('filter')
    filterList(newVal: ClientFilterOptions) {
        this.listOptions.filter = newVal;
        this.listOptions.pagerOptions.page = 1;
    }

    mounted() {
        this.isBusy = false;
        this.initFields();
        this.apiAccessToken = this.$store.state.apiAccessToken;
        this.loadClients();
        this.$root.$on('LocaleChanged', this.onLocaleChanged);
    }

    unmounted() {
        this.$root.$off('LocaleChanged');
    }

    initFields() {
        this.fields = [
            {
                key: 'sequenceId',
                label: this.$t('fields.id').toString(),
                headerTitle: 'Id',
                sortable: true,
                thStyle: 'width: 75px',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-nowrap datatable-cell text-dark-75 font-size-lg font-weight-bolder py-2',
                formatter: null
            },
            {
                key: 'name',
                label: this.$t('fields.name').toString(),
                headerTitle: 'Name',
                sortable: true,
                thStyle: '',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-wrap datatable-cell text-dark-75 font-size-lg font-weight-bolder py-2',
                formatter: null
            },
            {
                key: 'projects',
                label: this.$t('fields.projects').toString(),
                headerTitle: 'Projects',
                sortable: false,
                thStyle: '',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-wrap datatable-cell text-dark-75 font-size-lg py-2',
                formatter: null
            },
            {
                key: 'isActive',
                label: this.$t('fields.status').toString(),
                headerTitle: 'Status',
                sortable: true,
                thStyle: 'width: 100px',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: (value: boolean) => { return 'pt-5 pb-4 text-nowrap' + (value ? ' text-success' : ' text-danger'); },
                formatter: (value: boolean) => { return value ? 'status.active' : 'status.inactive'; }
            },
            {
                key: 'actions',
                label: '',
                headerTitle: '',
                sortable: false,
                thStyle: 'width: 110px',
                thClass: 'columnheader',
                tdClass: 'pl-3 pr-1 py-4 text-nowrap text-right',
                formatter: null
            }
        ];
    }

    async loadClients() {
        //this.isBusy = true;

        try {
            const response = await AxiosService.request<ServerData>({
                url: `clientsadministration/list`,
                method: 'POST',
                data: this.listOptions
            });

            this.clients = response.data.records ?? [];
            this.listOptions.pagerOptions = InitPagerOptions(response.data.totalRecordCount, response.data.pageCount, this.listOptions.pagerOptions.page, this.listOptions.pagerOptions.pageSize);
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
            this.$emit('load-complete');
        }
    }

    editClient(id: string) {
        this.$emit('client-selected', id);
    }

    deleteClient(client: ClientListItem) {
        if (client.projects.length != 0) {
            this.$bvModal.msgBoxOk(
                this.$t('modal.deniedClientDeleteMessage', { clientName: client.name }) as string, {
                    title: this.$t('modal.deniedClientDeleteTitle') as string,
                    centered: true,
                    buttonSize: 'sm',
                    okTitle: this.$t('modal.closeModal') as string
                }
            );
            return;
        }

        this.$bvModal.msgBoxConfirm(this.$t('modal.confirmClientDeleteMessage', { clientName: client.name }) as string, {
                title: this.$t('modal.confirmClientDeleteTitle') as string,
                centered: true,
                buttonSize: 'sm',
                okTitle: this.$t('modal.confirmOkTitle') as string,
                cancelTitle: this.$t('modal.confirmCancelTitle') as string
            })
            .then(value => {
                if (value) {
                    try {
                        AxiosService.request<ServerData>({
                            url: `clientsadministration?id=${client.id}`,
                            method: 'DELETE'
                        });

                        this.$root.$bvToast.toast(this.$t('toaster.clientDeleted', { clientName: client.name }) as string, {
                            title: this.$t('toaster.deleteClientTitle') as string,
                            autoHideDelay: Configuration.ToasterAutoHideDelay,
                            appendToast: true,
                            variant: Configuration.ToasterVariantSuccess,
                            toaster: Configuration.ToasterPosition
                        });
                        this.loadClients();
                    }
                    catch (error) {
                        if (error.response) {
                            switch (error.response.status) {
                                case 404:
                                    return this.$router.push(`/${i18n.locale}/notfound`);
                                case 403:
                                    return this.$router.push(`/${i18n.locale}/accessdenied`);
                                default:
                                    return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                            }
                        }
                    }
                    finally {
                        this.isBusy = false;
                    }
                }
            })
            .catch(error => {
                console.error(error);
            });
    }

    onChangePage(page: number) {
        this.listOptions.pagerOptions.page = page;
        this.loadClients();
    }

    onChangePageSize(pageSize: number) {
        this.listOptions.pagerOptions.pageSize = pageSize;
        this.listOptions.pagerOptions.page = 1;
        this.loadClients();
    }

    onSortChanged(e: TableSortEventArgs) {
        this.listOptions.sortOptions.sortBy = e.sortBy;
        this.listOptions.sortOptions.sortDirection = e.sortDesc ? -1 : 1;
        this.loadClients();
    }

    onLocaleChanged(locale: string) { // eslint-disable-line @typescript-eslint/no-unused-vars
        this.$nextTick(() => {
            this.initFields();
        });
    }
}

interface ServerData {
    records: ClientListItem[];
    totalRecordCount: number;
    pageCount: number;
}

interface ClientListItem {
    id: string;
    sequenceId: number;
    name: string;
    contactPerson: string;
    projects: EntityReference[];
    isActive: boolean;
    actions: string;
}

interface ClientListOptions {
    filter: ClientFilterOptions;
    pagerOptions: PagerOptions;
    sortOptions: SortOptions;
}
